import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { MobileAddOnCustomize } from "./component";
import {
  isCfarAvailableInChosenRoomProductSelector,
  hotelCfarQuoteFromChosenRoomProductSelector,
  cancellationPolicyFromChosenRoomProductSelector,
} from "../../../../shop/reducer";
import { IStoreState } from "../../../../../reducers/types";

const mapStateToProps = (state: IStoreState) => {
  return {
    isCfarAvailable: isCfarAvailableInChosenRoomProductSelector(state),
    cfarQuote: hotelCfarQuoteFromChosenRoomProductSelector(state),
    cancellationPolicy: cancellationPolicyFromChosenRoomProductSelector(state),
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileAddOnCustomizeConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileAddOnCustomize = withRouter(
  connector(MobileAddOnCustomize)
);
